import React, { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { TreemapChartVis } from '../../components'
import { useWindowDimensions } from '../../hooks'

interface Props {
	data: Charts.TreemapData
}

const ExploreExpensesLevel: React.FC<Props> = ({ data }) => {
	const history = useHistory()
	const location = useLocation()
	const { x, y } = useWindowDimensions()
	const handleLeafClick = useCallback(
		(leaf: any) => {
			return history.push(
				leaf.parent ? `/gastos/${leaf.data.id}` : location.pathname + '/tabla'
			)
		},
		[history, location]
	)

	const chartWidthToWindowWidthRatio = useMemo(() => {
		if (x >= 1800) {
			return 0.95
		} else if (x >= 1200) {
			return 0.925
		} else if (x >= 767) {
			return 0.91
		} else {
			return 0.825
		}
	}, [x])

	const chartHeightToWindowHeightRatio = useMemo(() => {
		if (y >= 700) {
			return 0.79
		} else if (y >= 600) {
			return 0.72
		} else {
			return 0.68
		}
	}, [y])

	return (
		<TreemapChartVis
			title='Explorar Gastos'
			dimensions={[
				x * chartWidthToWindowWidthRatio,
				y * chartHeightToWindowHeightRatio,
			]}
			data={data}
			onLeafClick={handleLeafClick}
		/>
	)
}

export default ExploreExpensesLevel
